import * as React from 'react'

import { observer } from 'mobx-react'

import MapViewSetUpStore from '../../MapViewSetUp.store'
import PdfToImageConverter from '../PdfToImageConverter'

interface IProps {
  store: MapViewSetUpStore
}

@observer
export default class PdfConverterDialog extends React.Component<IProps> {
  public render() {
    const { setConvertedPdf, selectedPdfFile } =
      this.props.store.sitemapControlStore
    return (
      <>
        {selectedPdfFile && (
          <PdfToImageConverter
            pdfFile={selectedPdfFile}
            uploadImage={setConvertedPdf}
          />
        )}
      </>
    )
  }
}
